// 手机买票——微信，主流程
const wxMainRoutes = Array.from({ length: 8 }, (_, i) => ({
  path: `vote/wx/index${i + 1}`,
  name: `voteWxIndex${i + 1}`,
  component: () => import(`@/views/traffic/vote/wx/index${i + 1}.vue`)
}))

// 手机买票——支付宝，主流程
const zfbMainRoutes = Array.from({ length: 5 }, (_, i) => ({
  path: `vote/zfb/index${i + 1}`,
  name: `voteZfbIndex${i + 1}`,
  component: () => import(`@/views/traffic/vote/zfb/index${i + 1}.vue`),
}));
// 手机买票——铁路12306，主流程
const tlMainRoutes = Array.from({ length: 5 }, (_, i) => ({
  path: `vote/tl/index${i + 1}`,
  name: `voteTlIndex${i + 1}`,
  component: () => import(`@/views/traffic/vote/tl/index${i + 1}.vue`),
}));

export default {
  path: '/traffic',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 手机买票——微信，开始
    ...wxMainRoutes,

    // 手机买票——支付宝，主流程
    ...zfbMainRoutes,
    // 手机买票——铁路12306，主流程
    ...tlMainRoutes,
  ],
};
